var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsDtz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "625px",
    height: "625px",
    viewBox: "0 0 625 625",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USDtz_svg_green_noborder"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#189DA3",
    fillRule: "nonzero",
    cx: 312.5,
    cy: 312.5,
    r: 312.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(312.500000, 309.832316) rotate(90.000000) translate(-312.500000, -309.832316) ",
    points: "7.62195264 228.658535 617.378047 228.658535 617.378047 391.006096 7.62195264 391.006096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5,579.268293 C459.83206,579.268293 579.268293,459.83206 579.268293,312.5 C579.268293,165.16794 459.83206,45.7317075 312.5,45.7317075 C205.033204,45.7317075 112.408439,109.277994 70.1515114,200.844759 C54.4761246,234.81184 45.7317075,272.634736 45.7317075,312.5 C45.7317075,459.83206 165.16794,579.268293 312.5,579.268293 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5,75.6516161 C181.69225,75.6516161 75.6516161,181.69225 75.6516161,312.5 C75.6516161,443.30775 181.69225,549.348384 312.5,549.348384 C443.30775,549.348384 549.348384,443.30775 549.348384,312.5 C549.348384,181.69225 443.30775,75.6516161 312.5,75.6516161 Z M312.5,110.343666 C424.14786,110.343666 514.656334,200.85214 514.656334,312.5 C514.656334,424.14786 424.14786,514.656334 312.5,514.656334 C200.85214,514.656334 110.343666,424.14786 110.343666,312.5 C110.343666,200.85214 200.85214,110.343666 312.5,110.343666 Z",
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#189DA3",
    fillRule: "nonzero",
    x: 7.62195121,
    y: 228.658537,
    width: 609.756098,
    height: 162.347561,
    rx: 81.1737805
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#189DA3",
    fillRule: "nonzero",
    x: 4.10742451,
    y: 225.729765,
    width: 609.756098,
    height: 162.347561,
    rx: 81.1737805
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(22.865853, 22.865853)",
    stroke: "#189DA3"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 6,
    cx: 289.634147,
    cy: 289.634147,
    r: 289.634147
  }), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    transform: "translate(22.865853, 22.865853)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 266.768293,
    cy: 266.768293,
    r: 266.768293
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 3,
    cx: 289.634147,
    cy: 289.634147,
    r: 278.20122
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.159846,154.344512 L332.158841,196.495535 C360.807101,200.224044 392.294207,213.369564 392.294207,240.442073 L392.294207,267.408537 L354.717988,267.408537 L354.717988,252.820122 C354.717988,239.115853 337.035061,229.832317 315.373476,229.832317 C294.153963,229.832317 275.58689,238.67378 275.58689,256.79878 C275.58689,278.018293 300.342988,286.859756 327.309451,296.143293 L332.988142,298.055607 L336.728864,299.347437 C368.570445,310.489128 401.135671,325.974815 401.135671,363.780488 C401.135671,400.219988 372.454895,422.64502 332.163799,428.257146 L332.159846,470.655488 L292.840154,470.655488 L292.838997,428.426934 C257.710694,423.818869 223.864329,406.215157 223.864329,376.158537 L223.864329,352.286586 L261.440549,352.286586 L261.440549,366.875 C261.440549,385.884147 287.964939,394.72561 312.721037,394.72561 C337.919207,394.72561 357.8125,384.557927 357.8125,365.990853 C357.8125,343.445122 333.056402,336.371951 302.11128,325.320122 L294.70153,322.51644 C263.721258,310.574647 232.26372,294.898938 232.26372,257.240853 C232.26372,221.328909 261.145161,202.92087 292.83924,197.276951 L292.840154,154.344512 L332.159846,154.344512 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsDtz);
export default __webpack_public_path__ + "static/media/USDtz.730a8b74107b9af2faec54d7ed0de866.svg";
export { ForwardRef as ReactComponent };